export default function(form) {
  const links = form.querySelectorAll('.description a');
  [...links].forEach((a) => {
    a.setAttribute('target', '_blank');
  })
}
